import { useEffect, memo } from 'react';
import { Stack } from '@mui/material';
import { useAppDispatch } from 'store';
import { fullScreen } from 'store/dialog/dialogSlice';
import useWidth from 'hooks/useWidth';

interface IDialogContentProps {
  width: { desktop: number | string; mobile?: number | string };
  height: { desktop: number | string; mobile?: number | string };
  children: React.ReactNode;
  padding?: string;
}

function DialogContent({ width, height, children, padding }: IDialogContentProps) {
  const dispatch = useAppDispatch();
  const _width = useWidth();
  const isMobile = _width === 'xs';

  let paddingValue = isMobile ? '32px 24px' : '30px';
  if (padding !== undefined) {
    paddingValue = padding;
  }

  useEffect(() => {
    dispatch(fullScreen({ fullScreen: isMobile }));
  }, [dispatch, isMobile]);

  return (
    <Stack
      sx={{
        width: { xs: width.mobile ?? '100vw', sm: width.desktop },
        height: { xs: height.mobile ?? '100vh', sm: height.desktop },
        padding: paddingValue,
        boxSizing: 'border-box',
      }}
    >
      {children}
    </Stack>
  );
}

export default memo(DialogContent);
